<div>
  <h3>Saved Properties</h3>
</div>
@if(loading) {
    <div class="like-list-loading-container">
        <app-loader></app-loader>
    </div>
} @else {
    <div class="like-list-container">
      @if (properties.length === 0) {
        <p>You have not saved any properties yet.</p>
      } @else {
        <mat-list>
            @for (property of properties; track property.id) {
              <mat-list-item class="like-list-property-item">
                <img 
                  matListItemAvatar 
                  class="like-list-property-img"
                  [src]="property.images[0].imageUrl || 'assets/images/home-placeholder.jpg'" 
                  alt="Property" 
                  width="100" 
                  height="100">
                <div matListItemTitle>
                  <strong>{{ property.displayName ?? property.propertyType | titlecase }} in {{ property.address.city }}, {{ property.address.state }}</strong>
                </div>
                <div matListItemLine>
                  {{ property.bedrooms }}BR • {{ property.bathrooms }}BA • ${{ property.cost }}/night
                </div>
                
                <!-- Right side: Heart + Price -->
                <div class="item-actions" matListItemLine>
                  <mat-icon color="warn">favorite</mat-icon>
                  <mat-icon color="primary" (click)="gotoProperty(property.id)">arrow_forward</mat-icon>
                </div>

              </mat-list-item>
              <mat-divider></mat-divider>
            }
        </mat-list>
      }
    </div>
}
